var map = {
	"./AdminIndex": 6758,
	"./AdminIndex.js": 6758,
	"./NavBar": 7548,
	"./NavBar.js": 7548,
	"./clients": 7180,
	"./clients/": 7180,
	"./clients/edit": 4969,
	"./clients/edit.js": 4969,
	"./clients/index": 7180,
	"./clients/index.js": 7180,
	"./clients/new": 3363,
	"./clients/new.js": 3363,
	"./commodities": 8968,
	"./commodities/": 8968,
	"./commodities/edit": 7741,
	"./commodities/edit.js": 7741,
	"./commodities/index": 8968,
	"./commodities/index.js": 8968,
	"./commodities/new": 2687,
	"./commodities/new.js": 2687,
	"./commodities/show": 8261,
	"./commodities/show.js": 8261,
	"./destinations": 1020,
	"./destinations/": 1020,
	"./destinations/edit": 660,
	"./destinations/edit.js": 660,
	"./destinations/index": 1020,
	"./destinations/index.js": 1020,
	"./destinations/new": 9254,
	"./destinations/new.js": 9254,
	"./destinations/show": 7054,
	"./destinations/show.js": 7054,
	"./kits/edit": 3770,
	"./kits/edit.js": 3770,
	"./parcels": 5962,
	"./parcels/": 5962,
	"./parcels/activate": 6154,
	"./parcels/activate.js": 6154,
	"./parcels/bulkActivate": 4718,
	"./parcels/bulkActivate.js": 4718,
	"./parcels/edit": 6289,
	"./parcels/edit.js": 6289,
	"./parcels/index": 5962,
	"./parcels/index.js": 5962,
	"./parcels/new": 8002,
	"./parcels/new.js": 8002,
	"./parcels/show": 3004,
	"./parcels/show.js": 3004,
	"./shipments/show": 8113,
	"./shipments/show.js": 8113,
	"./vessels": 8789,
	"./vessels/": 8789,
	"./vessels/edit": 2120,
	"./vessels/edit.js": 2120,
	"./vessels/index": 8789,
	"./vessels/index.js": 8789,
	"./vessels/new": 8059,
	"./vessels/new.js": 8059,
	"./vessels/show": 1117,
	"./vessels/show.js": 1117,
	"./zones": 6142,
	"./zones/": 6142,
	"./zones/edit": 9481,
	"./zones/edit.js": 9481,
	"./zones/index": 6142,
	"./zones/index.js": 6142,
	"./zones/new": 1601,
	"./zones/new.js": 1601,
	"./zones/show": 1062,
	"./zones/show.js": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5138;